import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import {Router} from '@angular/router';
import {IStreet} from '../../../../models/street.model';
import {IDistrict} from '../../../../models/district.model';
import {IDomain} from '../../../../models/domain.model';
import {ICity} from '../../../../models/city.model';
import {ICountry} from '../../../../models/country.model';
import {User} from '../../../../models/user.model';
import {UserService} from '../../../../services/user.service';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import {CommerciauxService} from "../../../../services/commerciaux.service";
import {DatePipe} from "@angular/common";
import { TemporaryUserResetEmail } from '../../../../models/temporaryuseresetemail.model';
import { ResetUserEmailService } from '../../../../services/resetuseremail.service';

@Component({
  selector: 'app-users-with-sold-products',
  templateUrl: './users-with-sold-products.component.html',
  styleUrls: ['./users-with-sold-products.component.scss']
})
export class UsersWithSoldProductsComponent implements OnInit {

    // @ts-ignore
    users: User[] = [];
    userFilter: User[] = [];
    // @ts-ignore
    currentUser: User = [];

    // @ts-ignore
    public year: number;
    // @ts-ignore
    public month: number;
    // @ts-ignore
    public day: number;
    // @ts-ignore
    public maxDate: Date;
    // @ts-ignore
    public minDate: Date;

    street: IStreet[] = [];
    district: IDistrict[] = [];
    domain: IDomain[] = [];
    cities: ICity[] = [];
    countries: ICountry[] = [];
  
    /*
   -----------------------------         for all page attribute    --------------------------------
   */
    page: number = 1;
    perPage: number = 15;
    totalItems: number = 0;
    tableSizes: any = [10, 15, 30, 50];
    search: any;
    seller = false;
  
    userForm : FormGroup;
    /*
    end for all page
     */
    sorted = false;
    sorted1 = false;
    sorted2 = false;
    sorted3 = false;
    sorted4 = false;
    sorted5 = false;
    sorted6 = false;
    sorted7 = false;
    sorted9 = false;
  
    isCommercial = false;
    isStillCommercial = false;
    emailForm: FormGroup;
    constructor(private commerciauxService : CommerciauxService,private datePipe: DatePipe,
                private router: Router, private fb: FormBuilder, private userService: UserService, private authService: AuthService) {}
    
    ngOnInit(): void {
  
      this.authService.isAuthenticated().subscribe(isAuthenticated => {
        this.loadUsers();
      },error=>{
        this.router.navigate(['/login']);
      });
    }
  
    loadUsers = () => {
      this.userService.getUsersWithSoldProducts(this.page-1, this.perPage, this.search).subscribe(data => {
          this.users = data.content;
          this.totalItems = data.totalElements;
          // console.log("-_-_-_-_-_-_-_-_-_-_-_-_-_-_-");
          // console.log(this.users);       
      }, (err) => {
        });
      this.seller = false;
    }
     
    onViewUser(id: any) {
      this.userService.getidUser(id).subscribe(rs => {
        this.currentUser = rs;
      });
      this.router.navigate(['users-with-sold-products-details', id]);
    }
  
  
    searchFilter($event: KeyboardEvent) {
      this.loadUsers();
    }
  
    displayPerPage(value: any) {
      this.perPage = parseInt(value, 10);
      this.loadUsers();
    }    
  
    sort1() {
      if(this.sorted1 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
        this.sorted1 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
        this.sorted1 = false;
  
      }
    }
    sort2() {
      if(this.sorted2 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.lastname.toLowercase  > b.lastname.toLowercase ? 1 : a.lastname < b.lastname ? -1 : 0)
        this.sorted2 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.lastname.toLowercase  < b.lastname.toLowercase  ? 1 : a.lastname > b.lastname ? -1 : 0)
        this.sorted2 = false;
      }
    }
    sort3() {
      if(this.sorted3 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.firstname > b.firstname ? 1 : a.firstname < b.firstname ? -1 : 0)
        this.sorted3 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.firstname < b.firstname ? 1 : a.firstname > b.firstname ? -1 : 0)
        this.sorted3 = false;
      }
    }
    sort4() {
      if(this.sorted4 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
        this.sorted4 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
        this.sorted4 = false;
      }
    }
    
    sort5() {
      if(this.sorted5 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
        this.sorted5 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
        this.sorted5 = false;
  
      }
    }
  
    sort6() {
      if(this.sorted6 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.gender > b.gender ? 1 : a.gender < b.gender ? -1 : 0)
        this.sorted6 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.gender < b.gender ? 1 : a.gender > b.gender ? -1 : 0)
        this.sorted6 = false;
  
      }
    }
  
    sort7() {
      if(this.sorted7 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.activated > b.activated ? 1 : a.activated < b.activated ? -1 : 0)
        this.sorted7 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.activated < b.activated ? 1 : a.activated > b.activated ? -1 : 0)
        this.sorted7 = false;
  
      }
    }
    
    sort9() {
      if(this.sorted9 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.sellerAuthorization > b.sellerAuthorization ? 1 : a.sellerAuthorization < b.sellerAuthorization ? -1 : 0)
        this.sorted9 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.sellerAuthorization < b.sellerAuthorization ? 1 : a.sellerAuthorization > b.sellerAuthorization ? -1 : 0)
        this.sorted9 = false;
  
      }
    }

    exportexcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('excel-table');
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName);
  
    }
}
